import UploadButton from "./upload-button";

export default UploadButton;
